module.exports = __webpack_public_path__ + "fonts/SuisseIntl-ThinItalic.50ec6a0.woff2";